// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-StudyList-MergeStudiesModal-module__authors";
var _2 = "webpack-concepts-Extraction-StudyList-MergeStudiesModal-module__cancel";
var _3 = "webpack-concepts-Extraction-StudyList-MergeStudiesModal-module__heading";
var _4 = "webpack-concepts-Extraction-StudyList-MergeStudiesModal-module__modalFooter";
var _5 = "webpack-concepts-Extraction-StudyList-MergeStudiesModal-module__reference";
var _6 = "webpack-concepts-Extraction-StudyList-MergeStudiesModal-module__referenceSelection";
var _7 = "webpack-concepts-Extraction-StudyList-MergeStudiesModal-module__studyId";
var _8 = "webpack-concepts-Extraction-StudyList-MergeStudiesModal-module__studyIdRadioButton";
var _9 = "webpack-concepts-Extraction-StudyList-MergeStudiesModal-module__title";
export { _1 as "authors", _2 as "cancel", _3 as "heading", _4 as "modalFooter", _5 as "reference", _6 as "referenceSelection", _7 as "studyId", _8 as "studyIdRadioButton", _9 as "title" }
